/**
 * Created by koppany.kiss on 2017. 08. 03..
 */

function checkTaxNumber(taxNumber) {
	let modulo = (taxNumber[0] * 9 + taxNumber[1] * 7 + taxNumber[2] * 3 + taxNumber[3] * 1 + taxNumber[4] * 9 + taxNumber[5] * 7 + taxNumber[6] * 3) % 10;
	let checkValue = modulo == 0 ? modulo : 10 - modulo;
	return checkValue == taxNumber[7];
}

export default checkTaxNumber;
